import { useEffect, useState } from 'react';
import moment from 'moment';
import 'moment-timezone';
import 'moment/locale/fr'; // Example: French
import 'moment/locale/en-gb'; // British English
import 'moment/locale/gu'; // Gujarati (if needed)
import i18next from 'i18next';

const useDateFormatter = () => {
    const [localTimeZone, setLocalTimeZone] = useState('');
    const [allLanguage, setAllLanguage] = useState("english");

    // Map custom language labels to Moment.js locales
    const localeMap = {
        english: 'en',
        guinea: 'fr',       // Assume 'guinea' uses French locale
        gujarati: 'gu',
    };

    // Set language according to the current browser language
    useEffect(() => {
        const browserLang = navigator.language;
        const appLang = browserLang === 'en-US' ? 'english' : 'guinea';
        i18next.changeLanguage(appLang);
        localStorage.setItem("handleSelectedLanguage", appLang);
    }, [navigator.language]);

    // Load stored language from localStorage
    useEffect(() => {
        const storeHandleSelectedLanguage = localStorage.getItem('handleSelectedLanguage');
        if (storeHandleSelectedLanguage) {
            setAllLanguage(storeHandleSelectedLanguage);
        }
    }, [localStorage.getItem('handleSelectedLanguage')]); // Only on mount

    // Get local time zone
    useEffect(() => {
        const timeZone = moment.tz.guess();
        setLocalTimeZone(timeZone);
    }, []);

    const formatDate = (dateString) => {
        if (!localTimeZone) {
            return '';
        }

        // Set the correct locale
        const momentLocale = localeMap[allLanguage.toLowerCase()] || 'en';
        moment.locale(momentLocale);

        // Format date string
        const localDateTime = moment.tz(dateString, localTimeZone);

        const format = allLanguage.toLowerCase() === 'guinea'
            ? 'DD MMMM YYYY HH:mm:ss'  // "10 mai 2025 14:33:00"
            : 'MMMM D, YYYY hh:mm:ss A'; // "2025-05-10 02:33:00 PM"

        return localDateTime.format(format);
    };

    return formatDate;
};

export default useDateFormatter;
